export const formSchema = {
	type: "object",
	required: [
		"type",
		"body",
	],
	properties: {
		type: {
			type: "string",
			title: "Type",
			enum: ["Business", "Personal"]
		},
		body: {
			type: 'string',
			title: "Notes",
			maxLength: 100
		},
	}
};

export const uiSchema = {

};
